import AppService from "./app-service"

export default class SpeciesService extends AppService {

  constructor() {
    super({ path: "species" })
  }
}